(() => {
  const requests = new Map();
  async function productsAt(path) {
    const existing = requests.get(path);
    if (existing && Date.now() - existing.at < 60000) return existing.promise;
    const promise = (async () => {
      const read = async page => {
        const url = new URL(path, location.origin);
        url.searchParams.set('view', 'getfly-size-data');
        url.searchParams.set('page', String(page));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('Inventory unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 100) throw new Error('Invalid inventory');
        return data;
      };
      const first = await read(1);
      const products = [...first.products];
      for (let page = 2; page <= first.pages; page += 3) {
        const batches = await Promise.all(Array.from({length: Math.min(3, first.pages - page + 1)}, (_, i) => read(page + i)));
        for (const batch of batches) products.push(...batch.products);
      }
      return products.filter(product => product.variants.some(variant => variant.price > 0));
    })();
    requests.set(path, {at: Date.now(), promise});
    try { return await promise; }
    catch (error) { requests.delete(path); throw error; }
  }
  async function update(details) {
    const links = Array.from(details.querySelectorAll('a[href]')).map(link => ({link, url: new URL(link.href)})).filter(({url}) => url.origin === location.origin && url.searchParams.has('category') && /\/collections\/(men|women|kids)$/.test(url.pathname));
    const paths = [...new Set(links.map(({url}) => url.pathname))];
    for (const path of paths) {
      try {
        const products = await productsAt(path);
        for (const {link, url} of links.filter(entry => entry.url.pathname === path)) {
          const category = url.searchParams.get('category');
          const available = products.some(product => category.startsWith('type:') ? 'type:' + String(product.type || '').trim().toLowerCase() === category : product.collections.includes(category));
          const item = link.closest('li');
          if (item) item.hidden = !available;
        }
      } catch {}
    }
  }
  document.addEventListener('toggle', event => {
    if (event.target instanceof HTMLDetailsElement && event.target.open && event.target.closest('getfly-navigation')) update(event.target);
  }, true);
})();

